export default __webpack_public_path__ + "static/media/chevron-double-right.23a913d5.svg";